import React, { Component } from 'react';
import {
   Col, Card, CardBody, Table, Row,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import CommonService from '../../../services/CommonService';
import global from '../../../global';

class SalesView extends Component {
    static propTypes = {
        pageid: PropTypes.string.isRequired,
    };

   constructor(props) {
      super(props);
      const { pageid } = this.props;
      this.salesId = pageid;
      this.state = {
         reportinfo: [],
         chequelist: [],
         customerlist: [],
      };
      this.userdata = JSON.parse(localStorage.getItem('userData'));
   }

   componentDidMount() {
      this.isLoading = true;
      this.loadSalesView();
   }

   loadSalesView = async () => {
      try {
         const response = await CommonService.getRows(`salesviewbyid/salesid/${this.salesId}`);
         if (this.isLoading && response) {
            this.setState({ reportinfo: response.reportinfo });
            this.setState({ chequelist: response.chequelist });
            this.setState({ customerlist: response.customerlist });
         }
      } catch (err) {
         console.log('Error: ', err.message);
         this.isLoading = false;
      }
   }

   render() {
      const { chequelist, customerlist, reportinfo } = this.state;
      const customersList = Object.values(customerlist);

      return (
         <Col md={12}>
            <Card className="panel panel--primary" id="users_table">
               <CardBody className="panel__body">
                  <div className="panel__title bg_blue">
                    <h5 className="bold-text">SALES REPORT - LOCATION</h5>
                  </div>
                    <div className="panel__content">
                        <Row>
                        <Col md={4} xs={12} sm={6}>
                            <div className="stock-box__container stock-sm stock-block">
                            <div className="stock-box outline stock-green">
                                <div className="stock-box__icon"><i className="fa fa-pallet" /></div>
                                <h3 className="stock-box__num">{reportinfo.sales_total}</h3>
                                <h4 className="stock-box__text">Total Sales</h4>
                            </div>
                            </div>
                        </Col>
                        <Col md={4} xs={12} sm={6}>
                            <div className="stock-box__container stock-sm stock-block">
                            <div className="stock-box outline stock-blue">
                                <div className="stock-box__icon"><i className="fa fa-pallet" /></div>
                                <h3 className="stock-box__num">{reportinfo.remit_total}</h3>
                                <h4 className="stock-box__text">Total Remitted</h4>
                            </div>
                            </div>
                        </Col>
                        <Col md={4} xs={12} sm={6}>
                            <div className="stock-box__container stock-sm stock-block">
                            <div className="stock-box outline stock-purple">
                                <div className="stock-box__icon"><i className="fa fa-pallet" /></div>
                                <h3 className="stock-box__num">{reportinfo.collection_total}</h3>
                                <h4 className="stock-box__text">Total Collection</h4>
                            </div>
                            </div>
                        </Col>
                        <Col md={4} xs={12} sm={6}>
                            <div className="stock-box__container stock-sm stock-block">
                            <div className="stock-box outline stock-red">
                                <div className="stock-box__icon"><i className="fa fa-pallet" /></div>
                                <h3 className="stock-box__num">{reportinfo.account_receivable}</h3>
                                <h4 className="stock-box__text">Total AR</h4>
                            </div>
                            </div>
                        </Col>
                        <Col md={4} xs={12} sm={6}>
                            <div className="stock-box__container stock-sm stock-block">
                            <div className="stock-box outline stock-red">
                                <div className="stock-box__icon"><i className="fa fa-pallet" /></div>
                                <h3 className="stock-box__num">{reportinfo.total_expenses}</h3>
                                <h4 className="stock-box__text">Total Expenses</h4>
                            </div>
                            </div>
                        </Col>
                        <Col md={4} xs={12} sm={6}>
                            <div className="stock-box__container stock-sm stock-block">
                            <div className="stock-box outline stock-red">
                                <div className="stock-box__icon"><i className="fa fa-pallet" /></div>
                                <h3 className="stock-box__num">{reportinfo.var_total}</h3>
                                <h4 className="stock-box__text">Total Variance</h4>
                            </div>
                            </div>
                        </Col>
                        </Row>
                    </div>

                    {/* Check Details */}
                    <div className="panel__content m-t-0">
                        <h4 className="bold p-x-10 p-t-15 border-bottom p-b-10">Check Details</h4>
                        <Table responsive striped>
                            <thead className="th-vtop">
                                <tr>
                                <th>Check Date</th>
                                <th>Customer</th>
                                <th>Ammount</th>
                                <th>Check Number</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                chequelist.length > 0 ? chequelist.map(item => (
                                    <tr key={item.payment_id} className="text-center">
                                        <td className="text-left">{item.cheque_date}</td>
                                        <td className="text-left">{item.customer_name}</td>
                                        <td className="text-left">&#x20B1; {item.amount ? item.amount : global.numberFormat(0)}</td>
                                        <td className="text-left">{item.cheque_number}</td>
                                    </tr>
                                )) : (
                                    <tr className="text-center">
                                        <td colSpan="4">No data available..</td>
                                    </tr>
                                )
                                }
                            </tbody>
                        </Table>
                    </div>

                    <div className="panel__content m-t-30">
                        <h4 className="bold p-x-10 p-t-15 border-bottom p-b-10">Customer List</h4>
                        <Table responsive striped>
                            <thead className="th-vtop">
                                <tr>
                                    <th>Customer</th>
                                    <th>Account Receivable</th>
                                    <th>Collection</th>
                                </tr>
                            </thead>
                            <tbody>
                                { customersList.length > 0 ? customersList.map((item, i) => (
                                    <tr key={`return_tr${i + 1}`} className="text-center">
                                        <td className="text-left">{item.customer_name}</td>
                                        <td className="text-left">&#x20B1; {item.balance ? item.balance : global.numberFormat(0)}</td>
                                        <td className="text-left">&#x20B1; {item.amount ? item.amount : global.numberFormat(0)}</td>
                                    </tr>
                                )) : (
                                    <tr className="text-center">
                                        <td colSpan="3">No data available..</td>
                                    </tr>
                                )
                                }
                            </tbody>
                        </Table>
                    </div>
               </CardBody>
            </Card>
         </Col>
      );
   }
}

export default withTranslation('common')(SalesView);
